import styled, { css } from 'styled-components';
import Wra16B from 'dc/Wra16B';
import Ico12 from 'dc/Ico12';
import { Typ20, Typ21 } from 'dc/Typ';

export const Wrapper = styled(Wra16B)`
  width: 100%;
  background-color: white;
`;

export const Icon = styled(Ico12)`
  color: #607d8b;
`;

export const Name = styled(Typ21)`
  flex-grow: 1;
`;

export const Activities = styled(Typ20)`
  margin-right: 100px; // To offset the Co2Label margin on desktop
`;

export const Co2Label = styled(Typ21)`
  margin-left: -100px;
`;

type HeaderProps = {
  isSmall?: boolean;
};

const Header = styled.th<HeaderProps>`
  white-space: nowrap;
  background-color: transparent;
  width: 0;
  ${props =>
    props.isSmall &&
    css`
      & > span {
        font-weight: normal;
      }
    `}
`;

export const HeaderHashtag = styled(Header)`
  padding-left: 8px;
  width: 66px;
`;

export const HeaderName = styled(Header)`
  text-align: start;
  padding: 16px 16px 16px 54px;
  width: initial;
`;

export const HeaderActivities = styled(Header)`
  text-align: start;
  padding: 16px;
`;

export const HeaderScore = styled(Header)`
  text-align: end;
  padding: 16px;
`;
